import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { CandidateInvitation } from "../../services/organization/organizationModel";

const InvitedCandidatesTable = ({
  candidateInvitations,
}: {
  candidateInvitations: CandidateInvitation[];
}) => {
  const { t } = useTranslation(["organization"]);

  return candidateInvitations.length > 0 ? (
    <table className="lblock table">
      <thead>
        <tr>
          <th>{t("organization:invited-candidates.table-headers.EMAIL")}</th>
          <th>
            {t("organization:invited-candidates.table-headers.SENT_DATE")}
          </th>
        </tr>
      </thead>
      <tbody>
        {candidateInvitations.map((candidateInvitation) => (
          <tr key={`candidate-invitation-${candidateInvitation.id}`}>
            <td>{candidateInvitation.email}</td>
            <td>
              {format(new Date(candidateInvitation.createdAt), "dd/MM/yyyy")}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div className="info --compact lblock">
      {t("organization:invited-candidates.NO_INVITATIONS_FOUND")}
    </div>
  );
};

export default InvitedCandidatesTable;
